import React from "react";
import { Avatar, AvatarFallback, AvatarImage } from "@pushpress/pushpress-ui";
import { cn } from "../../../utils/css";
import { SubscriptionCancelRequest } from "src/apis/metricsApi";
import { format } from "date-fns";
import { getFirstAndLastInitials, getFullName } from "../../../utils/names";

interface MemberCardProps {
  profilePic?: string;
  firstName: string | null;
  lastName: string | null;
  cardSubheading?: string;
  cancelRequest?: SubscriptionCancelRequest;
  onViewProfile: () => void;
}

export const MemberCard: React.FC<MemberCardProps> = ({
  profilePic,
  firstName,
  lastName,
  cardSubheading,
  cancelRequest,
  onViewProfile,
}) => {
  const fullName = getFullName([firstName, lastName]);
  const initials = getFirstAndLastInitials([firstName, lastName]);

  return (
    <div
      className={cn(
        "tw-flex tw-items-center tw-p-4 tw-cursor-pointer tw-shadow-none tw-rounded-lg",
        "hover:tw-bg-gray-50 hover:tw-border-gray-200 tw-border tw-border-transparent",
      )}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          onViewProfile();
        }
      }}
      role="button"
      tabIndex={0}
      onClick={onViewProfile}
    >
      <Avatar className="tw-border">
        <AvatarImage src={profilePic} />
        <AvatarFallback>{initials}</AvatarFallback>
      </Avatar>
      <div className="tw-flex-grow tw-ml-2">
        <p className="tw-text-sm tw-font-medium">{fullName}</p>
        {cardSubheading && (
          <p className="tw-text-xs tw-text-gray-500">{cardSubheading}</p>
        )}
        {cancelRequest && (
          <>
            <p className="tw-text-xs tw-text-gray-500">
              {`Plan: ${cancelRequest.planName}`}
            </p>
            <p className="tw-text-xs tw-text-gray-500">
              {`Date requested: ${format(
                new Date(cancelRequest.createdAt),
                "MMM d, yyyy",
              )}`}
            </p>
            <p className="tw-text-xs tw-text-gray-500">
              {`Next bill date: ${format(
                new Date(cancelRequest.nextChargeDate.replace("Z", "")),
                "MMM d, yyyy",
              )}`}
            </p>
          </>
        )}
      </div>
    </div>
  );
};
